import { useForm, usePage } from '@inertiajs/react';
import { Emblem } from '@/components/Emblem';
import { Button } from '@/components/ui/Button';
import { Field } from '@/components/ui/Field';
import { AlertError } from '@/components/ui/icons';

type LoginFormValues = {
  email: string;
  password: string;
};

export default function Login() {
  const { flash } = usePage().props;
  const { data, setData, post, processing, errors, transform } = useForm<LoginFormValues>({
    email: '',
    password: '',
  });

  // Devise's Warden strategy reads credentials from params[:admin], so the
  // outgoing payload must be nested under the `admin` scope key even though
  // the form's local state stays flat for simplicity.
  transform((formData) => ({ admin: formData }));

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post('/sign_in');
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-5 py-12">
      <div className="bg-surface border-line w-full max-w-sm rounded border p-8 sm:p-10">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <Emblem className="text-primary-deep size-9" title="The Touch" />
          <span className="font-display inline-flex items-baseline gap-1.5 text-[19px] tracking-[.01em]">
            <b className="font-semibold">PureTouch</b>
            <i className="text-ink-soft text-[0.85em] italic">by Daniela</i>
          </span>
          <h1 className="font-display mt-1 text-2xl font-semibold">Admin sign in</h1>
        </div>

        <form className="flex flex-col" onSubmit={onSubmit} noValidate>
          <Field
            label="Email"
            name="email"
            type="email"
            autoComplete="username"
            placeholder="you@example.com"
            value={data.email}
            onChange={(e) => setData('email', e.target.value)}
            error={errors.email?.[0]}
          />
          <Field
            label="Password"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="Your password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            error={errors.password?.[0]}
          />

          {flash?.error ? (
            <div
              role="alert"
              className="bg-error text-error-fg border-error-fg/30 mb-4 flex items-start gap-2 rounded border px-3 py-2.5 text-sm"
            >
              <AlertError className="mt-0.5 size-4 shrink-0" />
              <span>{flash.error}</span>
            </div>
          ) : null}

          <Button variant="solid" block type="submit" loading={processing} className="mt-2">
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
